const tags = window?.globalVariables?.product?.tags;

// only continue if there are any tags
if (tags) {

    // Find the pre order tag first
    const pre_order = tags.some(tag => tag.includes('pre-order'));

    // Only continue if the product is part of the pre-order collection
    if (pre_order) {

        // Only continue if the product is part of the pre-order collection
        const match = tags.find(tag => tag.startsWith('ships_by_'));

        if (match) {
            let preInterval = setInterval(function() {
            const preOrderContainer = document.getElementById('pre-order-container');

            if (preOrderContainer) {
                clearInterval(preInterval);
                // Strip 'ship_by_' from the tag
                const result = match.replace('ships_by_', '').trim();

                preOrderContainer.querySelector('button').innerHTML += ' - SHIPS ' + result;

            }
            }, 200);

        }

    }
}